import { createUserWithEmailAndPassword, signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../services/firebase.service';

const authService = {
  // 회원가입
  async signUp(email: string, password: string){
    try {
      await createUserWithEmailAndPassword(auth, email, password);
      alert('환영합니다.');

    } catch (err) {
      alert('회원가입에 실패하였습니다.');
    }
  },
  
  // 로그인
  async signIn(email: string, password: string){
    try {
      await signInWithEmailAndPassword(auth, email, password);
      alert('로그인에 성공했습니다.');

    } catch (err) {
      alert('로그인에 실패하였습니다.');
    }
  }
}

export default authService;